import React from "react";

import styles from "./IntegrationForm.module.css";
import {Button, ButtonState} from "../../../../../../elements/button/Button";
import {RootState} from "../../../../../../../app/store";
import {ValidatedForm} from "../../../../../../elements/validator/validatedForm/ValidatedForm";
import {FormHeader} from "../../../../../../elements/formHeader/FormHeader";
import {ConnectIntegrationRequest, Integration, UpdateIntegrationRequest} from "../../../../../../../api/generated";
import {IntegrationData} from "./components/integrationData/IntegrationData";
import {ConnectIntegrationRequestPartial} from "../../slice/connectIntegrationSlice";
import {UpdateIntegrationRequestPartial} from "../../slice/updateIntegrationSlice";

export type IntegrationRequest = ConnectIntegrationRequest | UpdateIntegrationRequest
export type IntegrationRequestPartial = ConnectIntegrationRequestPartial | UpdateIntegrationRequestPartial

export type IntegrationFormSelectionProvider = ({
    publicBotId: (state: RootState) => string | undefined;
    integration: (state: RootState) => Integration | undefined;

    superchatApiKey: (state: RootState) => string | undefined;
    superchatAimeUserEmail: (state: RootState) => string | undefined;
    superchatHandoverUserEmailList: (state: RootState) => string | undefined;
});

interface Props {
    isUpdateForm?: boolean
    formTitle: string
    onClose: () => any;
    onSubmit: () => any;
    updateRequest: (update: IntegrationRequestPartial) => void;
    selectionProvider: IntegrationFormSelectionProvider;
}

export const IntegrationForm = <T extends IntegrationRequest>({
                                                                  isUpdateForm = false,
                                                                  formTitle,
                                                                  onClose,
                                                                  onSubmit,
                                                                  updateRequest,
                                                                  selectionProvider,
                                                              }: Props) => {
    return <ValidatedForm<T> submitForm={onSubmit}>
        {(formCtx) => {
            const {formDisabled, onSubmitClick, updateValidationStatus, getMessage} = formCtx;
            return <div className={styles.wrapper}>
                <FormHeader
                    formTitle={formTitle}
                    onClose={onClose}
                />
                <div className={styles.fieldsWrapper}>
                    <IntegrationData<T>
                        isUpdateForm={isUpdateForm}
                        getMessage={getMessage}
                        updateRequest={updateRequest}
                        selectionProvider={selectionProvider}
                        updateValidationStatus={updateValidationStatus}
                    />
                </div>
                <div className={styles.buttonsWrapper}>
                    <Button
                        title={"Close"}
                        state={ButtonState.SECONDARY}
                        handleClick={() => onClose()}
                    />
                    <Button
                        title={formTitle}
                        state={formDisabled ? ButtonState.DISABLED : ButtonState.PRIMARY}
                        handleClick={() => onSubmitClick()}
                    />
                </div>
            </div>
        }}
    </ValidatedForm>
}



